import { FormLabel, Grid, TextField, Typography } from '@mui/material';
import { useProyecto } from '../../../data/ProyectoContext';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const CaracteristicasEspacio = () => {
    const { promptData, setPromptData } = useActividadesContext();
    const { proyecto, setProyecto } = useProyecto();

    const handleCharacterizationProyectChange = (event) => {
        const { value } = event.target;
        setProyecto({...proyecto, caracteristicas_espacio: value
        });
        setPromptData((prevData) => ({
            ...prevData,
            caracteristicas_espacio: value 
          }));
      };

    
    return (
        <Grid xs={12}>
            <Typography id="modal-modal-title" sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }} >Características del espacio</Typography>
            <FormLabel sx={{ fontFamily: 'montserrat', fontSize: '0.85rem' }}> Describe el entorno físico donde se llevará a cabo la actividad. Incluye información sobre los espacios disponibles (aula, patio, laboratorio, etc.) y los recursos materiales con los que cuenta (mobiliario, equipos tecnológicos, materiales didácticos, etc.).</FormLabel>
            <TextField
                required
                id="contexto"
                placeholder='Ejemplo: Disponibilidad del patio de la escuela (área aproximada de 200 m²) con césped y árboles. Acceso a 10 balones de diferentes deportes y un set de conos para marcar espacios.'
                name="contexto"
                fullWidth
                multiline
                rows={5}
                autoComplete="given-name"
                variant="outlined"
                value={promptData.caracteristicas_espacio}
                onChange={handleCharacterizationProyectChange}
                InputProps={{
                    sx: {
                        borderRadius:2,
                        mt:1,
                        mb: 3,
                        fontFamily: 'montserrat',
                        fontSize: '0.75rem',
                      color: '#336B87',
                        '&::placeholder': {
                          color: '#336B87',

                        },
                        '&:before': {
                            borderBottomColor: '#005559',

                        },
                        '&:after': {
                            borderBottomColor: '#005559',
                        },
                    }
                }}
            />
        </Grid>
    );
};

export default CaracteristicasEspacio;




